import { Component, forwardRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { EquipmentsApi } from '@core/api/equipments/equipments.api';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { PagedResult } from '@interfaces';
import _ from 'lodash';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../../main/equipments/i18n/en.json';
import spanish from '../../../../../main/equipments/i18n/es.json';
import portuguese from '../../../../../main/equipments/i18n/pt.json';

export function ValidateAutocomplete(): object {
  return { required: true };
}

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => EquipmentTypeLegacyComponent),
  multi: true
};

@Component({
  selector: 'equipment-type-legacy',
  templateUrl: './equipment-type.component.html',
  styleUrls: ['./equipment-type.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None
})
export class EquipmentTypeLegacyComponent implements ControlValueAccessor, OnInit {
  public equipmentsType: Array<any> = [];
  public inputValue = new FormControl();
  public hasSelectedEquipmentType: boolean;
  public selectedEquipmentType: any;
  public loading = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private equipmentsApi: EquipmentsApi
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  ngOnInit(): void {
    this.inputValue.valueChanges.pipe(debounceTime(500)).subscribe((value) => {
      this.equipmentsType = [];
      if (value) {
        this.searchEquipmentsTypes({ name_contains: value });
      }
    });
  }

  onChange: (_: any) => void = () => {};
  onTouched: (_: any) => void = () => {};

  searchEquipmentsTypes(query?): void {
    this.loading = true;
    this.equipmentsApi.searchEquipmentType(query).subscribe((result: PagedResult) => {
      this.loading = false;
      this.equipmentsType = result.items;
    });
  }

  writeValue(equipmentTypeId: any): void {
    if (equipmentTypeId) {
      this.equipmentsApi.searchOneEquipmentType(equipmentTypeId).subscribe((equipmentType) => {
        this.selectedEquipmentType = equipmentType;
        this.hasSelectedEquipmentType = true;
        this.inputValue.setErrors(null);
      });
    } else {
      this.deselectEquipmentType();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setSelectedEquipmentType(): void {
    if (this.inputValue.value) {
      this.onChange(this.inputValue.value);
      this.selectedEquipmentType = _.find(
        this.equipmentsType,
        (equipmentType) => equipmentType.id === this.inputValue.value
      );
      this.hasSelectedEquipmentType = true;
      this.inputValue.setErrors(null);
    }
  }

  deselectEquipmentType(): void {
    this.onChange(null);
    this.inputValue.setValue(null);
    this.selectedEquipmentType = null;
    this.hasSelectedEquipmentType = false;
    this.inputValue.setErrors(null);
  }
}
